import decamelizeKeysDeep from 'decamelize-keys-deep';
import getEnvironment from './environment';

const capitalize = word => `${word.slice(0, 1).toUpperCase()}${word.slice(1).toLowerCase()}`;

const camelize = (text, separator = '_') => {
  const words = text.split(separator);
  return [words[0], words.slice(1).map(word => capitalize(word)).join('')].join('');
};

// sets a defined list of properties from a source object to a target object
export const setNamedProperties = (
  targetObject, sourceObject, propertiesToSet, camelizePropertyNames = true
) => {
  if (typeof targetObject !== 'object' || typeof sourceObject !== 'object') {
    return;
  }
  (propertiesToSet || []).forEach((propertyName) => {
    const name = camelizePropertyNames ? camelize(propertyName) : propertyName;
    targetObject[name] = sourceObject[propertyName]; // eslint-disable-line no-param-reassign
  });
};

export const redirectTo = (href) => {
  if (getEnvironment() === 'development') {
    // eslint-disable-next-line no-console
    console.debug('Redirect (suppressed in development):', href);
    return;
  }
  window.location.assign(href);
};

export const reduceArrayToObject = (accumulator, element) => {
  if (!element) { throw new Error('Array element cannot be null.'); }
  if (element && element.id == null) { throw new Error('Array elements must have an id property.'); }

  accumulator[element.id] = element;
  return accumulator;
};

// Takes a 6-digit rgb hex code and returns either "#FFF" (white) or "#000" (black)
// as appropriate contrast color. Returns #000 (black) as default if hex code not valid
export const getContrastingTextColor = (hexCode) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = hexCode.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);

  // Parse hex code into three sections
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);

    // Calculate brightness
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Return label color based on brightness
    return brightness < 123 ? '#FFF' : '#000';
  }
  return '#000';
};

export const serializeObject = (object) => {
  const serialized = decamelizeKeysDeep(object);
  Object.keys(serialized).forEach((key) => {
    if (typeof serialized[key] === 'undefined') {
      delete serialized[key];
    }
  });
  return serialized;
};

export const generatePagerDutyId = () => `P${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
